import { render, staticRenderFns } from "./excel_becas.vue?vue&type=template&id=02e81ccc"
import script from "./excel_becas.vue?vue&type=script&lang=js"
export * from "./excel_becas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports